// Cotizador de envío — buscador de comuna (con lupa) que muestra el precio
// estimado antes de llegar al checkout, y deja la comuna elegida
// precargada en el botón "Finalizar compra" (vía query params de la URL de
// checkout que Shopify soporta nativamente) para que el cliente no tenga
// que volver a escribirla.
//
// Vive en dos lugares de la página al mismo tiempo (cart drawer + página
// de producto, ver snippets/shipping-comuna-estimate.liquid) — por eso
// todo acá opera sobre listas de elementos (querySelectorAll), nunca
// asume una sola instancia. Ambas comparten la misma comuna guardada en
// localStorage.
//
// El precio real que se cobra se sigue calculando en el checkout de verdad
// (Carrier Service de la app unitas-shipping-cost) — esto es solo un
// preview. Consulta /apps/shipping-cost/quote, un App Proxy de esa app: sin
// CORS porque para el navegador es same-origin (Shopify firma y reenvía el
// request server-side).
//
// Chile no tiene campo "Comuna" separado en el checkout de Shopify — el
// campo "City" cumple ese rol, así que prellenamos country + city + province
// (región). El cálculo de tarifa de todos modos solo depende de la comuna
// (city) — la región (province) es puramente para que al cliente no le
// quede el dropdown de región del checkout sin seleccionar. Probado en vivo
// contra el checkout real (ver REGION_BY_COMUNA más abajo): Shopify no
// exige que el string coincida literal con el texto del dropdown, así que
// nuestros 16 nombres de región funcionan tal cual, sin necesitar una tabla
// de códigos aparte.
(function () {
  const STORAGE_KEY = 'benis_shipping_comuna';
  const QUOTE_ENDPOINT = '/apps/shipping-cost/quote';

  // Mismo listado región -> comunas que usa la app de tarifas (349 comunas
  // de Chile). "San Fabián De Alico" existe una sola vez acá (bajo Ñuble,
  // su región real) aunque el tarifario fuente la tenga duplicada bajo
  // Maule también — ver memoria del proyecto unitas-shipping-cost.
  const REGIONS = [{"region":"Antofagasta","comunas":["Antofagasta","Calama","María Elena","Mejillones","Ollagüe","San Pedro de Atacama","Sierra Gorda","Taltal","Tocopilla"]},{"region":"Araucanía","comunas":["Angol","Carahue","Cholchol","Collipulli","Cunco","Curacautín","Curarrehue","Ercilla","Freire","Galvarino","Gorbea","Lautaro","Loncoche","Lonquimay","Los Sauces","Lumaco","Melipeuco","Nueva Imperial","Padre Las Casas","Perquenco","Pitrufquén","Pucón","Puerto Saavedra","Purén","Renaico","Temuco","Teodoro Schmidt","Toltén","Traiguén","Victoria","Vilcún","Villarrica"]},{"region":"Arica y Parinacota","comunas":["Arica","Camarones","General Lagos","Putre"]},{"region":"Atacama","comunas":["Alto Del Carmen","Caldera","Chañaral","Copiapó","Diego de Almagro","Freirina","Huasco","Tierra Amarilla","Vallenar"]},{"region":"Aysén","comunas":["Aysén","Chile Chico","Cisnes","Cochrane","Coyhaique","Guaitecas","Lago Verde","O'Higgins","Río Ibáñez","Tortel"]},{"region":"Biobío","comunas":["Alto Biobío","Antuco","Arauco","Cabrero","Cañete","Chiguayante","Concepción","Contulmo","Coronel","Curanilahue","Florida","Hualpén","Hualqui","Huépil","Laja","Lebu","Los Álamos","Los Ángeles","Lota","Mulchén","Nacimiento","Negrete","Penco","Quilaco","Quilleco","San Pedro de La Paz","San Rosendo","Santa Bárbara","Santa Juana","Talcahuano","Tirúa","Tomé","Tucapel","Yumbel"]},{"region":"Coquimbo","comunas":["Andacollo","Canela","Combarbalá","Coquimbo","Illapel","La Higuera","La Serena","Los Vilos","Monte Patria","Ovalle","Paihuano","Punitaqui","Río Hurtado","Salamanca","Vicuña"]},{"region":"O'Higgins","comunas":["Chimbarongo","Chépica","Codegua","Coinco","Coltauco","Doñihue","Graneros","La Estrella","Las Cabras","Litueche","Lolol","Machalí","Malloa","Marchihue","Nancagua","Navidad","Olivar","Palmilla","Paredones","Peralillo","Peumo","Pichidegua","Pichilemu","Placilla","Pumanque","Quinta de Tilcoco","Rancagua","Rengo","Requínoa","San Fernando","San Francisco Mostazal","San Vicente","Santa Cruz"]},{"region":"Los Lagos","comunas":["Ancud","Calbuco","Castro","Chaitén","Chonchi","Cochamó","Curaco de Vélez","Dalcahue","Fresia","Frutillar","Futaleufú","Hualaihué","Llanquihue","Los Muermos","Maullín","Osorno","Palena","Puerto Montt","Puerto Octay","Puerto Varas","Puqueldón","Purranque","Puyehue","Queilén","Quellón","Quemchi","Quinchao","Río Negro","San Juan de la Costa","San Pablo"]},{"region":"Los Ríos","comunas":["Corral","Futrono","La Unión","Lago Ranco","Lanco","Los Lagos","Mariquina","Máfil","Paillaco","Panguipulli","Río Bueno","Valdivia"]},{"region":"Magallanes","comunas":["Antártica","Cabo De Hornos","Laguna Blanca","Natales","Porvenir","Primavera","Punta Arenas","Río Verde","San Gregorio","Timaukel","Torres del Paine"]},{"region":"Maule","comunas":["Cauquenes","Chanco","Cholguan","Colbún","Constitución","Cumpeo","Curepto","Curicó","Empedrado","Hualañé","Licantén","Linares","Longaví","Maule","Molina","Parral","Pelarco","Pelluhue","Pencahue","Rauco","Retiro","Romeral","Río Claro","Sagrada Familia","San Clemente","San Javier","San Rafael","Talca","Teno","Vichuquén","Villa Alegre","Yerbas Buenas"]},{"region":"Región Metropolitana","comunas":["Alhué","Buin","Calera de Tango","Cerrillos","Cerro Navia","Colina","Conchalí","Curacaví","El Bosque","El Monte","Estación Central","Huechuraba","Independencia","Isla de Maipo","La Cisterna","La Florida","La Granja","La Pintana","La Reina","Lampa","Las Condes","Lo Barnechea","Lo Espejo","Lo Prado","Macul","Maipú","María Pinto","Melipilla","Padre Hurtado","Paine","Pedro Aguirre Cerda","Peñaflor","Peñalolén","Pirque","Providencia","Pudahuel","Puente Alto","Quilicura","Quinta Normal","Recoleta","Renca","San Bernardo","San Joaquín","San José de Maipo","San Miguel","San Pedro","San Ramón","Santiago","Talagante","Tiltil","Vitacura","Ñuñoa"]},{"region":"Ñuble","comunas":["Bulnes","Chillán","Chillán Viejo","Cobquecura","Coelemu","Coihueco","El Carmen","Ninhue","Pemuco","Pinto","Portezuelo","Quillón","Quirihue","Ránquil","San Carlos","San Fabián De Alico","San Ignacio","San Nicolás","Treguaco","Yungay","Ñiquén"]},{"region":"Tarapacá","comunas":["Alto Hospicio","Camiña","Colchane","Huara","Iquique","Pica","Pozo Almonte"]},{"region":"Valparaíso","comunas":["Algarrobo","Cabildo","Calera","Calle Larga","Cartagena","Casablanca","Catemu","Concón","El Quisco","El Tabo","Hijuelas","Isla de Pascua","Juan Fernández","La Cruz","La Ligua","Limache","Llaillay","Los Andes","Nogales","Olmué","Panquehue","Papudo","Petorca","Puchuncaví","Putaendo","Quillota","Quilpué","Quintero","Rinconada","San Antonio","San Esteban","San Felipe","Santa María","Santo Domingo","Valparaíso","Villa Alemana","Viña del Mar","Zapallar"]}];

  // Todas las comunas, sin agrupar, para el match de "¿esto es exactamente
  // una comuna válida?" (blur, restaurar desde localStorage).
  const ALL_COMUNAS = REGIONS.flatMap((r) => r.comunas);

  // comuna -> nombre de región, para prellenar también el dropdown
  // "Región" del checkout (checkout[shipping_address][province]). Probado
  // en vivo contra el checkout real: Shopify matchea por su propia base
  // geográfica, no por igualdad literal de string — funciona con nuestros
  // nombres tal cual (incluido "O'Higgins" con apóstrofe recto vs el "’"
  // curvo que usa Shopify internamente, y "Región Metropolitana" aunque
  // Shopify la muestre como "Santiago" en el dropdown).
  const REGION_BY_COMUNA = new Map(
    REGIONS.flatMap(({ region, comunas }) => comunas.map((c) => [c, region])),
  );

  const money = new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    maximumFractionDigits: 0,
  });

  function normalize(value) {
    return value
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '') // saca tildes/diacríticos
      .trim()
      .toLowerCase();
  }

  function setResult(resultEl, { state, text }) {
    resultEl.textContent = text;
    resultEl.dataset.state = state; // 'idle' | 'loading' | 'ok' | 'empty' | 'error' (CSS engancha acá)
  }

  function updateCheckoutLink(comuna) {
    // Solo existe en el cart drawer — en la página de producto no hay
    // botón de checkout cerca, así que esto es un no-op ahí.
    const checkoutLink = document.querySelector('.cart-drawer__checkout');
    if (!checkoutLink) return;
    if (!comuna) {
      checkoutLink.href = '/checkout';
      return;
    }
    const params = new URLSearchParams({
      'checkout[shipping_address][country]': 'Chile',
      'checkout[shipping_address][city]': comuna,
    });
    const region = REGION_BY_COMUNA.get(comuna);
    if (region) params.set('checkout[shipping_address][province]', region);
    checkoutLink.href = `/checkout?${params.toString()}`;
  }

  async function fetchEstimate(comuna, resultEl) {
    setResult(resultEl, { state: 'loading', text: 'Calculando…' });
    try {
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      const url = new URL(QUOTE_ENDPOINT, window.location.origin);
      url.searchParams.set('comuna', comuna);
      url.searchParams.set('grams', String(cart.total_weight || 0));
      // /cart.js expresa total_price en la unidad mínima (x100), igual que
      // toda la Cart AJAX API de Shopify — se pasa el monto real.
      url.searchParams.set('subtotal', String((cart.total_price || 0) / 100));

      const res = await fetch(url.toString());
      const data = await res.json();

      if (!data.ok) {
        setResult(resultEl, {
          state: 'empty',
          text: 'Todavía no tenemos tarifa cargada para esa comuna — se calculará en el pago.',
        });
        return;
      }

      const precioTexto = data.freeShipping ? 'Gratis' : money.format(data.price);
      setResult(resultEl, { state: 'ok', text: precioTexto });
    } catch (err) {
      console.error('Shipping estimate error:', err);
      setResult(resultEl, {
        state: 'error',
        text: 'No pudimos calcular el envío ahora — se calculará en el pago.',
      });
    }
  }

  // Arma la lista de <li> para el estado actual del buscador — agrupada
  // por región, ocultando grupos sin resultados. Sin query, muestra todo
  // (deja explorar por región igual que el <select> viejo).
  function buildListItems(listEl, query) {
    listEl.innerHTML = '';
    const q = normalize(query);
    const options = []; // en orden de aparición, para la navegación con flechas

    for (const { region, comunas } of REGIONS) {
      const matches = q ? comunas.filter((c) => normalize(c).includes(q)) : comunas;
      if (matches.length === 0) continue;

      const groupLabel = document.createElement('li');
      groupLabel.className = 'shipping-comuna-combobox__group';
      groupLabel.textContent = region;
      groupLabel.setAttribute('role', 'presentation');
      listEl.appendChild(groupLabel);

      for (const comuna of matches) {
        const item = document.createElement('li');
        item.className = 'shipping-comuna-combobox__option';
        item.textContent = comuna;
        item.setAttribute('role', 'option');
        item.dataset.comuna = comuna;
        listEl.appendChild(item);
        options.push(item);
      }
    }

    if (options.length === 0) {
      const empty = document.createElement('li');
      empty.className = 'shipping-comuna-combobox__empty';
      empty.textContent = 'Sin resultados';
      empty.setAttribute('role', 'presentation');
      listEl.appendChild(empty);
    }

    return options;
  }

  function initShippingEstimate(wrapper) {
    if (wrapper.dataset.initialized === 'true') return;
    wrapper.dataset.initialized = 'true';

    const input = wrapper.querySelector('[data-shipping-comuna-input]');
    const listEl = wrapper.querySelector('[data-shipping-comuna-list]');
    const resultEl = wrapper.querySelector('[data-shipping-result]');
    if (!input || !listEl || !resultEl) return;

    let options = [];
    let activeIndex = -1;
    let committedComuna = ''; // última comuna realmente seleccionada (no solo tipeada)

    function setActive(index) {
      if (activeIndex >= 0 && options[activeIndex]) {
        options[activeIndex].removeAttribute('aria-selected');
      }
      activeIndex = index;
      if (activeIndex >= 0 && options[activeIndex]) {
        options[activeIndex].setAttribute('aria-selected', 'true');
        options[activeIndex].scrollIntoView({ block: 'nearest' });
      }
    }

    function openList(query) {
      options = buildListItems(listEl, query);
      activeIndex = -1;
      listEl.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      // El footer del drawer tiene scroll propio: sin esto la lista (que
      // se abre hacia abajo) queda cortada por el borde del footer. Se sube
      // la tarjeta entera arriba para que el campo se vea completo con la
      // lista debajo (con 'nearest' el campo quedaba a medio cortar).
      if (wrapper.closest('.cart-drawer__footer')) {
        wrapper.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }

    function closeList() {
      listEl.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function selectComuna(comuna) {
      committedComuna = comuna;
      input.value = comuna;
      closeList();

      try {
        if (comuna) window.localStorage.setItem(STORAGE_KEY, comuna);
        else window.localStorage.removeItem(STORAGE_KEY);
      } catch (err) {
        // storage no disponible (modo privado, etc.) — no es crítico
      }

      updateCheckoutLink(comuna);

      if (!comuna) {
        setResult(resultEl, { state: 'idle', text: '' });
        return;
      }
      fetchEstimate(comuna, resultEl);
    }

    listEl.addEventListener('click', (event) => {
      const item = event.target.closest('[data-comuna]');
      if (!item) return;
      selectComuna(item.dataset.comuna);
    });

    input.addEventListener('input', () => {
      openList(input.value);
    });

    input.addEventListener('focus', () => {
      openList(input.value);
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (listEl.hidden) openList(input.value);
        setActive(Math.min(activeIndex + 1, options.length - 1));
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActive(Math.max(activeIndex - 1, 0));
      } else if (event.key === 'Enter') {
        event.preventDefault();
        if (activeIndex >= 0 && options[activeIndex]) {
          selectComuna(options[activeIndex].dataset.comuna);
        }
      } else if (event.key === 'Escape') {
        closeList();
      }
    });

    input.addEventListener('blur', () => {
      // Da tiempo al click en un <li> (blur dispara antes que click) antes
      // de decidir si hay que revertir el texto tipeado.
      setTimeout(() => {
        closeList();
        const typed = input.value.trim();
        const exact = ALL_COMUNAS.find((c) => normalize(c) === normalize(typed));
        if (exact) {
          if (exact !== committedComuna) selectComuna(exact);
        } else {
          // No es una comuna real — vuelve a la última seleccionada (o
          // queda vacío si nunca se eligió una).
          input.value = committedComuna;
        }
      }, 150);
    });

    document.addEventListener('click', (event) => {
      if (!wrapper.contains(event.target)) closeList();
    });

    // Restaura la comuna guardada de una visita anterior, si sigue en la lista.
    try {
      const saved = window.localStorage.getItem(STORAGE_KEY);
      if (saved && ALL_COMUNAS.includes(saved)) {
        committedComuna = saved;
        input.value = saved;
        updateCheckoutLink(saved);
        fetchEstimate(saved, resultEl);
      }
    } catch (err) {
      // ignore malformed/unavailable storage
    }
  }

  function initAll() {
    document.querySelectorAll('[data-shipping-estimate]').forEach(initShippingEstimate);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAll();

    // El carrito se refresca reemplazando el innerHTML de .cart-drawer__inner
    // completo (ver refreshCartDrawer en theme.js) — eso se lleva puesto
    // nuestra instancia del cart drawer y sus listeners cada vez que cambia
    // una cantidad. En vez de tocar theme.js, reobservamos ese contenedor y
    // reinicializamos cuando cambian sus hijos directos (childList sin
    // subtree: así los <li> que agregamos nosotros mismos más abajo no
    // disparan un loop).
    const inner = document.querySelector('.cart-drawer__inner');
    if (inner) {
      new MutationObserver(initAll).observe(inner, { childList: true });
    }
  });
})();
